export interface ITranslateProps<T = Record<string, any>, U = Record<string, any>> {
  i18nKey: string | string[];
  values?: T;
  tOptions?: U;
}

export type TranslationCountry = 'MX' | 'BR' | 'US';

export enum Languages {
  EN = 'en',
  PT = 'pt',
  ES = 'es',
}
